<template>
	<!--pages-->
	<section class="page-content">
		<ul class="fx-align" v-show ="pageNum > 1">
			<li>
				共{{totalCount}}条
			</li>
			<li v-show="index !=1">
				<a @click="handleJump(offset-count)">
					上一页
				</a>
			</li>
			<li>
				{{index}}/{{pageNum}} {{pages}}
			</li>
			<li v-show="index !=pageNum">
				<a @click="handleJump(offset+count)">
					下一页
				</a>
			</li>
			<li class="fx-align">
				<p><input type="number" v-model.trim = "jumpIndex"  @keyup.enter = "handlePageClick"/> </p>
				<p class="p-l-5"><a @click="handlePageClick">跳转</a> </p>
			</li>
		</ul>
	</section>
</template>

<script>
	export default {
		name:"z-pages",
		/*
		 * 接收父组件数据
		 */
		data() {
				return {
					pageNum: 0, //有多少页
					index:0, //当前第几页
					jumpIndex:null // 跳转到第几页
				}
			},
			props: {
				offset:{
					type: Number,
      				default: 0
				},
				count:{
					type: Number,
      				default: 0
				},
				totalCount:{
					type: Number,
      				default: 0
				}
			},
			/*
			 * 实例计算属性
			 */
			computed: {
				pages() {
					this.pageNum = Math.ceil(this.totalCount / this.count); //共多少页
					this.index = Math.ceil(this.offset / this.count)+1; //当前第几页
					return ''
				},
			},
			/*
			 * 处理事件
			 */
			methods: {
				handleJump(offset){
					this.$emit('handleOffset',offset)
				},
				handlePageClick() {
					let jumpNum = Number(this.jumpIndex)
					if(!jumpNum || jumpNum < 1) return
					if(jumpNum > this.pageNum) jumpNum = this.pageNum
					
					this.$emit('handleOffset',(parseInt(jumpNum) - 1)*this.count)
				}
			}
	}
</script>

<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.page-content {
		li{
			padding:0 px-em(10px);
			a{
				color:$color-main;
				/*border: $color-btn 1px solid;
				background:$color-btn;
				padding:px-em(5px) px-em(20px);*/
			}
			input{
				width: px-em(100px);
				border: $color-btn 1px solid;
				padding:px-em(5px) px-em(20px);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Pages.vue?4bfdffc0